import { render } from "./top-nav.vue?vue&type=template&id=48fcb8e2&scoped=true"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"

import "./top-nav.vue?vue&type=style&index=0&id=48fcb8e2&lang=scss&scoped=true"

import exportComponent from "D:\\dev_program\\web\\haorun-changliuxiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fcb8e2"]])

export default __exports__